<template>
    <div class="dropDown task" :class="task.id" :key="task.id">
        <div @click="openEditTask" class="card-body">
            <div class="card-container">
                <strong class="mb-1 my-auto card-body-title">
                    {{ task.title || "No title" }}
                    <!-- Why not to put notif to tags section? -->
                    <span class="board-notif" v-if="hasUnseen">
                        <span class="inner-board-notif"></span>
                    </span>
                </strong>
                <!-- <Label/> -->
                <div class="card-bottom">
                    <div class="task-portraits" :class="{'right-space': hasUnseen}">
                        <div
                            v-for="(tag, t) in task?.tags"
                            :key="`${task.id}-${tag?.id}-${t}`"
                            :class="`tag-${tag.tagType} task-portraits__portrait`"
                            @mouseenter="hoverStart($event, tag)"
                        >
                            <img v-if="tag?.tagType == 'user' && tag?.portrait" :src="baseURL + tag.portrait">
                            <span v-else-if="tag?.tagType == 'user'">{{ tag?.username?.charAt(0).toUpperCase() }}</span>
                            <div v-else>
                                <i v-if="tag?.symbol" :style="{ 'color': `${tag?.color}` }" :class="`icon-${tag?.symbol}`"></i>
                                <span v-else>{{ tag?.name }}</span>
                            </div>
                        </div>
                    </div>
                    <span class="checklist-count">{{ checklistCount }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Label from "@/components/atoms/Label.vue";
import {baseURL} from "@/mixins/helpers";

export default {
    data() {
        return {
            tooltipContent: '',
            activeUserEl: null,
            userTooltip: null,
            hoveringOverCard: false,
            baseURL: baseURL()
        }
    },
    name: "TaskCard",
    components: {
		Label
	},
    props: ["task", "listItem"],
    mounted() {
        this.userTooltipContainer = document.querySelector('.user-info-tooltip')
        this.userTooltip = this.userTooltipContainer.querySelector('.tooltip')

        this.userTooltipContainer.addEventListener('mouseleave', this.clearUserInfo)
    },
    methods: {
        openEditTask() {
            this.$emit('openEditTask', this.task, this.listItem)
        },
        updateEditTask() {
            this.$store.dispatch('setEditableTask', this.task)
        },
        hoverStart(event, user) {
            if(user.tagType == 'tag') return
            this.userTooltip.innerHTML = `
                        <div class="tooltip__flex">
                            ${ user.portrait ? 
                                `<img class="tooltip__img" src="${this.baseURL + user.portrait}">` :
                                `<span class="tooltip__img">${ user?.username?.charAt(0).toUpperCase() }</span>`
                            }
                        </div>
                        ${
                            user.id === `user:${this.currentUser?.id}` ?
                            `<div class="tooltip__edit">
                                <span>(You)</span>
                                <a href="/app/my-profile">
                                    <img src="${require('@/assets/images/edit-blue.svg')}" alt="">
                                </a>
                            </div>` : ''
                        }
                        <div class="tooltip__label">Name:</div>
                        <div class="tooltip__paragraph">${ user.name || '' }</div>
                        <div class="tooltip__label">Username:</div>
                        <div class="tooltip__paragraph">${ user.username }</div>
                        <div class="tooltip__label">Bio:</div>
                        <div class="tooltip__paragraph">${ this.formatBio(user.bio) || '' }</div>
            `;

            this.userTooltipContainer.style.display = 'block'
            this.activeUserEl = event.target

            this.$nextTick(() => this.setTooltipPosition())
        },
        clearUserInfo() {
            this.userTooltip.innerText = ''
            this.userTooltipContainer.style.display = 'none'
            this.activeUserEl = null
        },
        setTooltipPosition() {
            if (!this.userTooltipContainer) return

            const userRect = this.activeUserEl.getBoundingClientRect()
            
            this.userTooltipContainer.style.left = userRect.left + 'px';
            this.userTooltipContainer.style.top = userRect.bottom + 'px';
        },
        formatBio(bio) {
            return bio ? bio.replace('\n', '<br />') : ''
        },
    },
    computed: {
        editableTask() {
            return this.$store.getters.editableTask
        },
        currentUser() {
            return this.$store.getters.currentUser
        },
        hasUnseen() {
            let user = String(this.currentUser.id)
            let events = this.task.events?.map(e => e.unseen)
            let result = false
            events?.forEach(e => {
              if(e.includes(user)) result = true
            })
            //console.log(this.task.events)
            return result
        },
        checklistCount() {
            let checkedItems = (this.task.body.match(/- \[x\]/g) || []).length
            let allCheckItems = (this.task.body.match(/- \[ \]/g) || []).length + (this.task.body.match(/- \[x\]/g) || []).length

            if(checkedItems !== allCheckItems) {
                return `${checkedItems}/${allCheckItems}`
            } else {
                return ''
            }
        }
    }
};
</script>

<style lang="scss">
.task {
    cursor: pointer;
}

.dropDown {
    overflow-x: visible !important;
    overflow-y: visible !important;

    .tooltip {
        display: block;
    }
}

.card-body-title {
    word-break: break-word;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    font-weight: 400;
}

.card-container {
    flex-direction: column !important;
}

.card-bottom {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: row-reverse;

    .checklist-count {
        font-size: 12px;
        color: #989898;
    }
}

.task-portraits {
    display: flex;
    gap: 5px;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end;
    min-height: 25px; // should be the same height as portrait image + margin

    &.right-space {
        padding-right: 25px;
    }
    img, span {
        width: 20px;
        height: 20px;
        object-fit: cover;
        display: block;
        border-radius: 50%;
        margin-top: 5px;
    }
    span {
        background-color: #fff;
        color: #8d8d8d;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .tag-user {
        order: 2;
    }

    .tag-tag {
        order: 1;
        i {
            display: block;
            font-size: 19px;
            margin-top: 5px;
        }
    }
}

.user-info-tooltip > * { min-width: 120px; }
</style>
